module.exports = __webpack_public_path__ + "static/media/kampus_merdeka_logo.4455fb03.png";